"use strict";
/**
 * Further reading on ideas behind these utility types
 *
 * See: https://stackoverflow.com/questions/55904032/how-to-get-optional-property-from-union
 */
Object.defineProperty(exports, "__esModule", { value: true });
